<template>
  <div id="wrapper">
    <div class="businessIntroduction-1"></div>
    <div class="businessIntroduction-2"></div>
  </div>
</template>

<script>
    export default {
      name: "businessIntroduction",
      data() {
        return {
        }
      },
      methods: {

      },
      mounted() {

      }
    }
</script>

<style scoped>
  .businessIntroduction-1{
    position: relative;
    max-height: 42.94rem;
    padding-top: 35%;
    background: url("../../static/images/home/businessIntroduction-1.png") no-repeat center / cover;
  }
  .businessIntroduction-2{
    position: relative;
    max-height: 49.69rem;
    padding-top: 41%;
    background: url("../../static/images/home/businessIntroduction-2.png") no-repeat center / cover;
  }

  @media (max-width: 768px) {
    .businessIntroduction-1{
      position: relative;
      max-height: 119.81rem;
      padding-top: 256%;
      margin: 5rem auto;
      background: url("../../static/images/home/businessIntroductionH5-1.png") no-repeat center / cover;
    }

    .businessIntroduction-2{
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/businessIntroduction.vue